import React, { useEffect, useState } from "react"; 
import OffplanCard from "./OffplanCard";

const OffplanbycityHome = ({ city, home = "Yes" }) => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";

  useEffect(() => {
    fetch(`${API}/api/offplanlistingbycity.ashx`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ city,home })
    })
      .then(res => res.json())
      .then(res => {
        if (res.result === 1) {          // <-- fixed here
          setListings(res.data);          // <-- set the array
        } else {
          console.error("Error:", res.message);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [city,home]);

  if (loading) return <p>Loading featured properties...</p>;

  return (
    <div className="row">
      {listings.map(item => (
        <OffplanCard key={item.id} item={item} />
      ))}
    </div>
  );
};

export default OffplanbycityHome;
